'use client';

import cn from 'classnames';
import Image from 'next/image';
import { useMemo, useState } from 'react';

import { Gallery } from '@utils/article/processor/replacer';


interface ArticleGalleryProps {
  gallery: Gallery;
}
export default function ArticleGallery({ gallery }: ArticleGalleryProps) {
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);

  const selectedImage = useMemo(() => {
    return gallery.images[selectedImageIndex];
  }, [selectedImageIndex, gallery.images]);

  if (!selectedImage) {
    return null;
  }

  return (
    <div className="w-full py-4">
      <div className="relative flex max-h-64 w-full items-center justify-center overflow-hidden rounded-2xl lg:max-h-96">
        <Image
          className="h-auto w-full object-cover"
          src={selectedImage.src}
          width={selectedImage.width}
          height={selectedImage.height}
          alt={selectedImage.alt}
        />
        {selectedImage.caption && (
          <p className="absolute bottom-0 left-0 w-full bg-gradient-to-t from-black to-transparent px-2 py-3 text-center text-xs text-white">
            {selectedImage.caption}
          </p>
        )}
      </div>
      <div className="grid w-full grid-cols-2 gap-1 py-3 md:grid-cols-4 lg:grid-cols-8">
        {gallery.images.map((image, index) => (
          <button
            key={index}
            className={cn('overflow-hidden rounded-lg border', {
              'border-premium-500': index === selectedImageIndex,
            })}
            onClick={() => setSelectedImageIndex(index)}
          >
            <Image
              src={image.src}
              alt={image.alt}
              width={image.width}
              height={image.height}
            />
          </button>
        ))}
      </div>
    </div>
  );
}
